import React, {useRef} from "react";
import styles from "../styles/general.module.scss";
import {Channel, MessageInput, MessageList, Thread, Window, withChatContext} from "stream-chat-react";
import CustomChannelHeader from "./CustomChannelHeader";

const ConversationBox = ({client, openDir}) => {

    return (
        <div className={`${styles.conversation} ${styles[openDir]}`} >
            <Channel client={client} >
                <Window hideOnThread={true}>
                    <CustomChannelHeader me={client.user} />
                    <MessageList client={client} closeThread={console.log} />
                    <MessageInput focus />
                </Window>
                <Thread fullWidth />
            </Channel>
        </div>
    );
};

export default withChatContext(ConversationBox);